import Flickity from "react-flickity-component";
import { useFirebase } from "../providers/firebase";
import { useAuthentication } from "../providers/authentication";
import { useState, useEffect } from "react";

const flickityOptions = {
  initialIndex: 0,
  autoPlay: 3000,
  wrapAround: true,
  pauseAutoPlayOnHover: false,
  selectedAttraction: 0.015,
};

function Carousel() {
  const { user } = useAuthentication();
  
  const { photos: firebasePhotos, deletePhoto } = useFirebase();
  const [photos, setPhotos] = useState([]);

  // Sync photos from Firebase to local state
  useEffect(() => {
    setPhotos(firebasePhotos);
  }, [firebasePhotos]);

  const handleDeletePhoto = (id) => {
    console.log(id);
    deletePhoto(id, 'photos').then(()=> window.location.reload()); // Remove from Firebase or database

    // Update local state to trigger re-render
    // setPhotos((prevPhotos) => prevPhotos.filter((photo) => photo.id !== id));
  };

  return (
    <>
      {photos && photos.length > 0 ? (
        <Flickity
          className="carousel"
          elementType={"div"}
          options={flickityOptions}
          disableImagesLoaded={false}
          reloadOnUpdate
          static
        >
          {photos.map((photo) => (
            <div className="image-div" key={photo.id}>
              <img
                src={photo.link}
                alt="carousel-item"
                className="carousel-cell"
              />
              {user && (
                <button
                  onClick={() => handleDeletePhoto(photo.id)}
                  className="remove-photo-button"
                  style={{
                    color: "white",
                    backgroundColor: "red",
                    border: "none",
                  }}
                >
                  Remove
                </button>
              )}
            </div>
          ))}
        </Flickity>
      ) : (
        <div>No photos available.</div>
      )}
    </>
  );
}

export default Carousel;
